<template>
  <Container>
    <!-- ! 왼쪽 섹션 -->
    <LeftSection>
      <LoginWrapper>

        <!-- * 헤더 -->
        <HeaderContainer>
          <LogoContainer>
            <img src="/icon.png" alt="로고" />
          </LogoContainer>
          <WelcomeTextContainer>
            <WelcomeText>환영합니다</WelcomeText>
            <SubWelcomeText>로그인 정보를 입력해주세요.</SubWelcomeText>
          </WelcomeTextContainer>
        </HeaderContainer>

        <!-- * 로그인 폼 -->
        <FormContainer>
          <InputContainer>
            <Form @submit.prevent="handleSubmit">
              <Input type="text" id="id" v-model="id" placeholder="아이디 입력" autocomplete="username"
                @focus="showSavedAccounts = true" />
              <Input type="password" id="password" v-model="password" placeholder="비밀번호 4자리 이상 입력"
                autocomplete="current-password" />

              <!-- * 로그인 버튼 -->
              <SubmitButton type="submit" @click.prevent="handleSubmit">로그인</SubmitButton>

              <!-- * 카카오 로그인 버튼 -->
              <KakaoButton type="button" @click="handleKakaoLogin">
                카카오 로그인
              </KakaoButton>
            </Form>
          </InputContainer>
        </FormContainer>
      </LoginWrapper>
    </LeftSection>

    <!-- ! 오른쪽 섹션 -->
    <RightSection />
  </Container>
</template>

<script>
import * as LoginPage from "@/assets/styles/global/LoginCss.js";

export default {
  name: "LoginPage",

  components: {
    ...LoginPage,
  },

  data() {
    return {
      id: "",
      password: "",
    };
  },

  async mounted() {
    // 로그인 페이지 진입 시 모든 스토리지 정리
    this.clearAllStorageOnLoginPage();
    // 페이지 로드 시 카카오 콜백 처리
    await this.handleKakaoCallback();
  },

  methods: {
    // 로그인 페이지 진입 시 모든 스토리지 정리
    clearAllStorageOnLoginPage() {
      try {
        // 특정 키들을 명시적으로 삭제
        const specificKeys = [
          'orderPageVisited',
          'orderPageData',
          'orderFilters',
          'orderSearchHistory',
          'orderSortSettings',
          'orderPageSize',
          'orderCurrentPage',
          'claimPageData',
          'productPageData',
          'rentalPageData',
          'managePageData',
          'accountPageData',
          'schedulePageData',
          'deliveryPageData',
          'dataPageData',
          'companyPageData',
          'feedbackPageData',
          'excelPageData',
          'popbillPageData',
          'oxygenPageData',
          'stockPageData',
          'supportPageData',
          'categoryPageData',
          'commentPageData',
          'memberPageData',
          'statusPageData'
        ];

        // 로컬 스토리지에서 특정 키들 삭제
        specificKeys.forEach(key => {
          if (localStorage.getItem(key)) {
            localStorage.removeItem(key);
          }
        });

        // 세션 스토리지에서 특정 키들 삭제
        specificKeys.forEach(key => {
          if (sessionStorage.getItem(key)) {
            sessionStorage.removeItem(key);
          }
        });

        // 로컬 스토리지 완전 삭제
        localStorage.clear();

        // 세션 스토리지 완전 삭제
        sessionStorage.clear();

        // 카카오 인증 데이터도 정리
        this.clearKakaoAuthDataQuick();

        // 추가 검증: 실제로 삭제되었는지 확인
        this.verifyStorageCleared();

      } catch (error) {
        console.error('로그인 페이지 스토리지 정리 중 오류 발생:', error);
      }
    },

    // 스토리지가 실제로 삭제되었는지 검증
    verifyStorageCleared() {
      try {
        const localStorageKeys = Object.keys(localStorage);
        const sessionStorageKeys = Object.keys(sessionStorage);

        if (localStorageKeys.length > 0) {
          console.warn('로컬 스토리지에 남아있는 키들:', localStorageKeys);
          // 남아있는 키들을 강제로 삭제
          localStorageKeys.forEach(key => {
            localStorage.removeItem(key);
          });
        }

        if (sessionStorageKeys.length > 0) {
          console.warn('세션 스토리지에 남아있는 키들:', sessionStorageKeys);
          // 남아있는 키들을 강제로 삭제
          sessionStorageKeys.forEach(key => {
            sessionStorage.removeItem(key);
          });
        }

      } catch (error) {
        console.error('스토리지 검증 중 오류 발생:', error);
      }
    },

    async handleSubmit() {
      if (!this.id || !this.password) {
        this.$swal.fire("입력 오류", "계정과 비밀번호를 입력해주세요.", "error");
        return;
      }

      try {
        const response = await this.$axios.post(`${this.$apiUrls.hanqmedi}/login`,
          {
            id: this.id,
            password: this.password,
          },
          {
            withCredentials: true,
            headers: { 'Content-Type': 'application/json' }
          }
        );

        if (response.data.statusCode === 200) {
          const token = response.data.token;

          // 서버에서 받은 모든 데이터를 그대로 사용
          const userInfo = {
            ...response.data.userInfo,
          };

          // company_key 값 찾기
          let companykey = userInfo.company_key;

          if (!companykey) {
            console.error('❌ company_key를 찾을 수 없습니다:', userInfo);
            this.$swal.fire("로그인 실패", "회사 정보를 찾을 수 없습니다.", "error");
            return;
          }

          // JWT 토큰과 사용자 정보를 localStorage에 저장
          localStorage.setItem('token', token);
          localStorage.setItem('userInfo', JSON.stringify(userInfo));

          // 전역 상태에 사용자 정보 설정
          this.$setGlobalState('id', userInfo.id);
          this.$setGlobalState('manager_name', userInfo.user_name);
          this.$setGlobalState('company_name', userInfo.company);
          this.$setGlobalState('company_key', companykey);

          this.$swal.fire("로그인 성공", "환영합니다!", "success")
          this.$router.push("/order");
        } else {
          this.$swal.fire("로그인 실패", response.data.message, "error");
        }
      } catch (error) {
        console.error("오류:", error);
        let message = "서버 오류로 인해 로그인에 실패했습니다.";
        if (error.response && error.response.data) {
          message = error.response.data.message || message;
        }
        this.$swal.fire("로그인 실패", message, "error");
      }
    },

    // 카카오 로그인 시작 - 최적화 버전
    async handleKakaoLogin() {
      try {
        const redirectUri = this.$getKakaoRedirectUri();

        // 1. API 호출과 정리를 동시에 실행 (병렬)
        const [response] = await Promise.all([
          this.$axios.get(`${this.$apiUrls.hanqmedi}/kakaoAuthUrl`, {
            params: { redirect_uri: redirectUri },
            timeout: 3000  // 3초 타임아웃 설정
          }),
          // 백그라운드에서 정리 (결과 기다리지 않음)
          this.clearKakaoAuthDataQuick()
        ]);

        if (response.data.statusCode === 200) {
          // 즉시 이동
          window.location.href = response.data.authUrl;
        } else {
          this.$swal.fire("카카오 로그인 실패", response.data.message, "error");
        }
      } catch (error) {
        console.error("카카오 로그인 오류:", error);

        // 타임아웃이나 네트워크 오류 시 대체 방법
        if (error.code === 'ECONNABORTED' || error.message.includes('timeout')) {
          this.$swal.fire({
            icon: "warning",
            title: "서버 응답 지연",
            text: "직접 카카오 로그인으로 이동하시겠습니까?",
            showCancelButton: true,
            confirmButtonText: "이동",
            cancelButtonText: "취소"
          }).then((result) => {
            if (result.isConfirmed) {
              // 프론트엔드에서 직접 URL 생성
              const kakaoAuthUrl = this.buildKakaoAuthUrl();
              window.location.href = kakaoAuthUrl;
            }
          });
        } else {
          this.$swal.fire("카카오 로그인 실패", "카카오 로그인 중 오류가 발생했습니다.", "error");
        }
      }
    },

    // 빠른 정리 (필수 항목만)
    async clearKakaoAuthDataQuick() {
      return new Promise(resolve => {
        setTimeout(() => {
          try {
            // 로컬 스토리지만 빠르게 정리
            Object.keys(localStorage).forEach(key => {
              if (key.includes('kakao')) {
                localStorage.removeItem(key);
              }
            });
          } catch (error) {
            console.warn('정리 중 오류 (무시):', error);
          }
          resolve();
        }, 0);
      });
    },

    // 대체 카카오 URL 생성
    buildKakaoAuthUrl() {
      const REST_API_KEY = process.env.VUE_APP_KAKAO_REST_API_KEY;
      const redirectUri = this.$getKakaoRedirectUri();
      return `https://kauth.kakao.com/oauth/authorize?response_type=code&client_id=${REST_API_KEY}&redirect_uri=${encodeURIComponent(redirectUri)}`;
    },

    // 카카오 콜백 처리
    async handleKakaoCallback() {
      try {
        const urlParams = new URLSearchParams(window.location.search);
        const code = urlParams.get('code');
        const error = urlParams.get('error');

        if (error) {
          this.$swal.fire("카카오 로그인 실패", "카카오 로그인 중 오류가 발생했습니다.", "error");
          return;
        }

        if (!code) return;

        window.history.replaceState({}, document.title, window.location.pathname);

        const redirectUri = this.$getKakaoRedirectUri();

        const response = await this.$axios.post(`${this.$apiUrls.hanqmedi}/kakaoLogin`, {
          code: code,
          redirect_uri: redirectUri
        }, {
          withCredentials: true,
          headers: { 'Content-Type': 'application/json' }
        });

        if (response.data.statusCode === 200) {
          const token = response.data.token;

          // 서버에서 받은 모든 데이터를 그대로 사용
          const userInfo = {
            ...response.data.userInfo,
          };


          let companykey = userInfo.company_key;

          if (!companykey) {
            console.error('❌ 카카오 로그인 - company_key를 찾을 수 없습니다:', userInfo);
            this.$swal.fire("카카오 로그인 실패", "회사 정보를 찾을 수 없습니다.", "error");
            return;
          }

          // JWT 토큰과 사용자 정보를 localStorage에 저장
          localStorage.setItem('token', token);
          localStorage.setItem('userInfo', JSON.stringify(userInfo));

          // 전역 상태에 사용자 정보 설정
          this.$setGlobalState('id', userInfo.id);
          this.$setGlobalState('manager_name', userInfo.user_name);
          this.$setGlobalState('company_name', userInfo.company);
          this.$setGlobalState('company_key', companykey);

          this.$swal.fire("카카오 로그인 성공", "환영합니다!", "success");
          this.$router.push("/order");
        } else {
          this.$swal.fire("카카오 로그인 실패", response.data.message, "error");
        }
      } catch (error) {
        console.error("카카오 콜백 오류:", error);
        let message = "카카오 로그인 처리 중 오류가 발생했습니다.";
        if (error.response && error.response.data) {
          message = error.response.data.message || message;
        }
        this.$swal.fire("카카오 로그인 실패", message, "error");
      }
    }
  },
}
</script>